<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>终端授权</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="queryParams.code" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.approval_status">
                <vDropdown
                    model_key="approval_status"
                    model_name="请选择审批状态"
                    select_value="value"
                    request_uri="dropdownApprovalStatus"
                    :model_value_default="queryParams['approval_status']"
                    @onDropChange="onDropChange"
                    ref="approval_status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <vDropdown
                    model_key="status"
                    model_name="请选择状态"
                    select_value="value"
                    request_uri="dropdownCommonStatus"
                    :model_value_default="queryParams['status']"
                    @onDropChange="onDropChange"
                    ref="status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.business_rid">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item" v-if="postList.terminal_rid">
                <vSearchSelect
                    model_key="terminal_rid"
                    model_name="请输入终端搜索"
                    request_uri="searchAccounts"
                    default_option_key="terminal_option"
                    :default_option="queryParams['terminal_option']"
                    @onDropChange="onDropChange"
                    ref="terminal_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item" v-if="postList.representative_rid">
                <vDropdown
                    model_key="representative_rid"
                    model_name="请选择代表"
                    :model_value_default="queryParams['representative_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="representative_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.date">
                <el-date-picker
                    v-model="queryParams['date']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn" :loading="btnLoading"
                    >新增</el-button
                >
                <el-button size="small" plain @click="match" v-if="postList.matchBtn" :loading="btnLoading">匹配流向</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="terminal_authorization" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>

                <div v-show="is_show_help">
                    <div class="flex">
                        <span style="color: red; font-size: 13px">
                            1. 草稿状态可编辑或删除，当进入审批流程后不允许操作（可在宜搭端进行撤销或通知审批人拒绝）
                        </span>
                    </div>
                    <div class="flex">
                        <span style="color: red; font-size: 13px">
                            2. 禁用不会中断审批流程，但是禁用后就算审批通过也无效了。禁用不改变历史数据
                        </span>
                    </div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="terminal_authorization"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div
                                v-if="
                                    in_array(item.prop, [
                                        'code',
                                        'business',
                                        'terminal',
                                        'product',
                                        'representative',
                                        'submission_operator_name',
                                        'decision_operator_name'
                                    ])
                                "
                            >
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="禁用" placement="top-start">
                            <i class="el-icon-error" @click="disable(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="提交" placement="top-start">
                            <i class="el-icon-success" @click="submit(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'terminalAuthorizationComponent',
    data() {
        return {
            draggable: {
                data_name: 'terminal_authorization'
            },
            is_show_help: false,
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['code']) && row.rid) {
                this.$router.push({
                    path: '/terminalAuthorizationDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'business' && row.business_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.business_rid
                    }
                });
            } else if (prop == 'terminal' && row.terminal_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.terminal_rid
                    }
                });
            } else if (prop == 'representative' && row.representative_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.representative_rid
                    }
                });
            } else if (prop == 'product' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (prop == 'submission_operator_name' && row.submission_operator_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.submission_operator_rid
                    }
                });
            } else if (prop == 'decision_operator_name' && row.decision_operator_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.decision_operator_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                code: '',
                approval_status: '',
                business_rid: '',
                terminal_rid: '',
                product_rid: '',
                date: '',
                representative_rid: '',
                status: ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('terminal_authorization_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('terminal_authorization_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('terminal_authorization', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).terminal_authorization;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'terminalAuthorizationLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.getList();
        },
        //新增
        insert() {
            this.$router.push({
                path: 'terminalAuthorizationEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //增量匹配流向
        match() {
            this.$confirm('您确定要匹配流向吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['terminalAuthorizationMatch']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'terminalAuthorizationEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'terminalAuthorizationEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        disable(rid) {
            this.$confirm('您确定要禁用吗，禁用后不能重新开启？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['terminalAuthorizationDisable']({ rid: rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },
        submit(rid) {
            this.$confirm('您确定要提交？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['terminalAuthorizationSubmit']({ rid: rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'terminalAuthorizationDelete', row.name);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>